import styled, { css } from 'styled-components';

import { color } from '../../../atoms/colors';
import { spacing } from '../../../atoms/spacing';
import { atMinWidth } from '../../../atoms/breakpoints';

export const Modal = styled.div`
  position: fixed;
  inset: 0px;
  width: 100vw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 250ms ease-in-out 0s, visibility 250ms ease-in-out 0s;
  z-index: 9999;

  ${({ isOpen }) =>
    isOpen
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `}
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0px;
  width: 100vw;
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(111, 126, 140, 0.22);
  backdrop-filter: blur(4px);
  transition: opacity 250ms ease-in-out 0s, visibility 250ms ease-in-out 0s;
  z-index: 9999;
  cursor: pointer;

  ${({ isOpen }) =>
    isOpen
      ? css`
          opacity: 1;
          visibility: visible;
        `
      : css`
          opacity: 0;
          visibility: hidden;
        `}
`;

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;

  ${atMinWidth.md`
    width: 768px;
    max-height: 520px;
    padding: ${spacing[20]};
  `}
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${color.common.white};
  border: 1px solid ${color.darkBlue[50]};
  box-shadow: 0px 32px 64px -12px rgba(16, 24, 40, 0.14);
  overflow: hidden;

  ${atMinWidth.md`
    border-radius: ${spacing[16]};
    max-height: 520px;
  `}
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: ${spacing[16]};
`;

export const Content = styled.div`
  width: calc(100% - 4px);
  height: 100%;
  padding: ${spacing[32]} ${spacing[12]};
  border-radius: ${spacing[16]};
  overflow-y: scroll;

  ${atMinWidth.md`
    max-height: 520px;
    padding: ${spacing[16]} ${spacing[12]};
  `}
`;
